import MainPage from "./main-ui/MainPage";
import Instructions from "./applicationprocess/Instructions";
import ApplicationForm from "./applicationprocess/ApplicationForm";
import StatusPage from "./applicationprocess/StatusPage";
import PvtOfficersLogin from "./LoginPages/private-officers/PvtOfficersLogin";
import PrintForm from "./LoginPages/private-officers/PrintForm";
import ScholarList from "./LoginPages/private-officers/ScholarList";
import PendingPaymentList from "./LoginPages/private-officers/PendingPaymentList";
import PendingPlagiarismList from "./LoginPages/private-officers/PendingPlagiarismList";
import PendingVerificationList from "./LoginPages/private-officers/PendingVerificationList";
import PaymentDetails from "./LoginPages/private-officers/PaymentDetails";
import VerifyDetails from "./LoginPages/private-officers/VerifyDetails";
import PlagiarismDetails from "./LoginPages/private-officers/PlagiarismDetails";
import BOSPanelLogin from "./LoginPages/bos-panel/BOSPanelLogin";
import BOSPanelsList from "./LoginPages/bos-panel/BOSPanelsList";
import BOSFormFill from "./LoginPages/bos-panel/BOSFormFill";
import CertificateTemplate from "./applicationprocess/CertificateTemplate";
import { ProtectedRoute1, ProtectedRoute2, ProtectedRoute3 } from "./ProtectedRoute";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ForgotPassword from "./main-ui/ForgotPassword";
import PendingOfficersList from "./LoginPages/acoe-coe-vc/PendingOfficersList";
import OfficersLogin from "./LoginPages/acoe-coe-vc/OfficersLogin";
import BOSListAcoe from "./LoginPages/acoe-coe-vc/BOSListAcoe";
import AcoeNote1 from "./LoginPages/note-pages/AcoeNote1"
import CoeNote1 from "./LoginPages/note-pages/CoeNote1"
import VcNote1 from "./LoginPages/note-pages/VcNote1"
import AcoeNote2 from "./LoginPages/note-pages/AcoeNote2"
import CoeNote2 from "./LoginPages/note-pages/CoeNote2"
import VcNote2 from "./LoginPages/note-pages/VcNote2"
import AcoeNote3 from "./LoginPages/note-pages/AcoeNote3"
import CoeNote3 from "./LoginPages/note-pages/CoeNote3"
import VcNote3 from "./LoginPages/note-pages/VcNote3"
import NavBar from "./components/NavBar";
import BOSFormView from "./LoginPages/bos-panel/BOSFormView";
import BOSPanelPrint from "./LoginPages/acoe-coe-vc/BOSPanelPrint";
import ErrorPage from "./components/Errorpage";

function App() {
  return (
    <Router>
      <NavBar />
      <Routes>
        <Route path="/" exact element={<MainPage />} />
        <Route path="/pvtOfficer-login" element={<PvtOfficersLogin />} />
        <Route path="/" element={<ProtectedRoute2 />}>
          <Route path="/status" element={<StatusPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/instructions" element={<Instructions />} />
          <Route path="/application" element={<ApplicationForm />} />
        </Route>
        <Route path="/" element={<ProtectedRoute1 />}>
          <Route
            path="/pending-payment-list"
            element={<PendingPaymentList />}
          />
          <Route
            path="/pending-plagiarism-list"
            element={<PendingPlagiarismList />}
          />
          <Route
            path="/pending-verification-list"
            element={<PendingVerificationList />}
          />
          <Route exact path="/payment-details" element={<PaymentDetails />} />
          <Route exact path="/verify-details" element={<VerifyDetails />} />
          <Route
            exact
            path="/plagiarism-details"
            element={<PlagiarismDetails />}
          />
        </Route>

        <Route exact path="/bospanel-login" element={<BOSPanelLogin />} />
        <Route exact path="/bospanels-list" element={<BOSPanelsList />} />
        <Route exact path="/bos-fill-form" element={<BOSFormFill />} />
        <Route exact path="/bospanel-view" element={<BOSFormView />} />

        <Route exact path="/officers-login" element={<OfficersLogin />} />
        <Route path="/certificate" element={<CertificateTemplate />} />
        <Route path="/pendingnotes" element={<PendingOfficersList />} />
        <Route path="/acoenote1" element={<AcoeNote1 />} />
        <Route path="/coenote1" element={<CoeNote1 />} />
        <Route path="/vcnote1" element={<VcNote1 />} />
        <Route path="/acoenote2" element={<AcoeNote2 />} />
        <Route path="/coenote2" element={<CoeNote2 />} />
        <Route path="/vcnote2" element={<VcNote2 />} />
        <Route path="/acoenote3" element={<AcoeNote3 />} />
        <Route path="/coenote3" element={<CoeNote3 />} />
        <Route path="/vcnote3" element={<VcNote3 />} />
        <Route path="/boslistacoe" element={<BOSListAcoe />} />
        <Route path="/bospanelprint" element={<BOSPanelPrint />} />
        <Route path="/scholarlist" element={<ScholarList />} />
        <Route path="/scholarprint" element={<PrintForm />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}
export default App;
